import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Button } from "../../../components/button";
import { UserInput } from "../../users/components";
import { useMe } from "../../users/hooks/useMe";
import { UserRole } from "../../../__generated__/globalTypes";

interface CreateReferenceInput {
  name: string;
  url: string;
  imgUrl: string;
  reference: string;
  lastQuantity: number;
  lastPrice: number;
  userId: number;
}

interface ReferenceFormProps {
  loading: boolean;
  submit: any;
  form: UseFormReturn<CreateReferenceInput, any>;
}

export const ReferenceForm: React.FC<ReferenceFormProps> = ({
  loading,
  submit,
  form,
}) => {
  const { data: userData } = useMe();
  const isAdmin = userData?.me?.role === UserRole.Admin;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex flex-wrap -m-3 mb-2">
        {/* User - Admin Only */}
        {isAdmin && (
          <div className="w-full p-3">
            <UserInput form={form} label="Utilisateur *" required={true} />
          </div>
        )}

        {/* Name */}
        <div className="w-full md:w-1/2 p-3">
          <p className="mb-1.5 font-medium text-base text-gray-800">
            Nom du produit *
          </p>
          <input
            className="w-full input"
            type="text"
            {...form.register("name", { required: "Nom requis" })}
            placeholder="Ex: MacBook Pro 16"
          />
          {form.formState.errors.name && (
            <p className="text-red-500 text-xs mt-1">
              {form.formState.errors.name.message}
            </p>
          )}
        </div>

        {/* Reference Code */}
        <div className="w-full md:w-1/2 p-3">
          <p className="mb-1.5 font-medium text-base text-gray-800">
            Référence
          </p>
          <input
            className="w-full input"
            type="text"
            {...form.register("reference")}
            placeholder="Ex: MBP-16-2024"
          />
        </div>

        {/* URL */}
        <div className="w-full p-3">
          <p className="mb-1.5 font-medium text-base text-gray-800">
            URL du produit *
          </p>
          <input
            className="w-full input"
            type="url"
            {...form.register("url", { required: "URL requise" })}
            placeholder="https://example.com/product"
          />
          {form.formState.errors.url && (
            <p className="text-red-500 text-xs mt-1">
              {form.formState.errors.url.message}
            </p>
          )}
        </div>

        {/* Image URL */}
        <div className="w-full p-3">
          <p className="mb-1.5 font-medium text-base text-gray-800">
            URL de l'image
          </p>
          <input
            className="w-full input"
            type="url"
            {...form.register("imgUrl")}
            placeholder="https://example.com/image.jpg"
          />
        </div>

        {/* Price */}
        <div className="w-full md:w-1/2 p-3">
          <p className="mb-1.5 font-medium text-base text-gray-800">Prix (€)</p>
          <input
            className="w-full input"
            type="number"
            step="0.01"
            {...form.register("lastPrice", {
              valueAsNumber: true,
              required: "Prix requis",
            })}
            placeholder="0.00"
          />
          {form.formState.errors.lastPrice && (
            <p className="text-red-500 text-xs mt-1">
              {form.formState.errors.lastPrice.message}
            </p>
          )}
        </div>

        {/* Quantity */}
        <div className="w-full md:w-1/2 p-3">
          <p className="mb-1.5 font-medium text-base text-gray-800">
            Quantité
          </p>
          <input
            className="w-full input"
            type="number"
            {...form.register("lastQuantity", {
              valueAsNumber: true,
              required: "Quantité requise",
            })}
            placeholder="0"
          />
          {form.formState.errors.lastQuantity && (
            <p className="text-red-500 text-xs mt-1">
              {form.formState.errors.lastQuantity.message}
            </p>
          )}
        </div>
      </div>

      <div className="flex gap-3 mt-4">
        <Button
          disabled={!form.formState.isValid}
          loading={loading}
          onClick={submit}
        >
          Créer la Référence
        </Button>
      </div>
    </div>
  );
};
